import { render } from "./component.vue?vue&type=template&id=f649dcca&scoped=true"
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"

import "./component.vue?vue&type=style&index=0&id=f649dcca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f649dcca"]])

export default __exports__